export const userRoles = {
  ADMIN: 'admin',
  ENTERPRISE_ADMIN: 'Administrador da Empresa',
  MANAGER: 'Gerente',
  PORTARIA: 'Portaria',
  FINANCEIRO: 'Financeiro',
  VISUALIZATION: 'Visualizador',
  KLABIN_MANAGER: 'Gestor Klabin',
};
